// tsfunctions.js

// pcdiffs = function (tsNav) {
//   if (!tsNav instanceof TS) {
//     console.log('tsfunctions:vami tsNav invalid', tsNav)
//   }
// }

var vami = function (tsNav, baseValue = 100.0, date = 'start') {
  if (tsNav === null || tsNav === undefined) {
    return null
  }
  if (date === null || date === undefined) {
    return null
  }
  if (!tsNav.isEmpty()) {
    if (date === 'start') {
      date = tsNav.startDate()
    } else if (typeof date === 'object') {
      date = date.toISOString().slice(0, 10)
    }

    const startValues = tsNav.data[date]
    var newTs = tsNav.clone()

    for (const date1 in tsNav.data) {
      var values = tsNav.data[date1]
      var newValues = []
      for (var colNo = 0; colNo < values.length; colNo++) {
        if (startValues[colNo] === 0 || values[colNo] === 0) {
          newValues.push(baseValue)
        } else {
          newValues.push(values[colNo] / startValues[colNo] * baseValue)
        }
      }
      newTs.data[date1] = newValues
    }
    return newTs
  } else {
    return null
  }
}

export default {
  vami
}
